import { render } from "./AddEditUser.vue?vue&type=template&id=56b879aa"
import script from "./AddEditUser.vue?vue&type=script&lang=js"
export * from "./AddEditUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__